module.exports = "/_next/static/images/slide5-2x-e250ae1e9601240503511598a317078e.jpg.webp";